import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import axios from 'axios';
import history from '@/history';
const ACCESS_TOKEN = 'token';

//接口地址
const baseURL = process.env.REACT_APP_BASE_URL || 'https://zhao.funengyun.cn/api';
//静态资源url
const staticUrl = process.env.REACT_APP_STATIC_URL || 'https://file.zhao.funengyun.cn';
const request = axios.create({
  baseURL,
  headers: {
    'content-type': 'application/json'
  },
  timeout: 6000
});
request.interceptors.request.use(config => {
  const token = localStorage.getItem(ACCESS_TOKEN);
  token && (config.headers[ACCESS_TOKEN] = token);
  return config;
});
request.interceptors.response.use(response => {
  const err_msg = response.data.msg || '服务器错误';
  if (response.data.code === -9999) {
    _Message.error(err_msg);
    setTimeout(() => {
      history.push('/login');
    }, 1000);
    return;
  }
  return response.data;
});
export default request;
export { baseURL, staticUrl };